import SuperRepository from '../superRepository'

export default new class stopWordRepo extends SuperRepository {
  baseUri () {
    return 'stop_word'
  }
  put = async (params) => this.httpClient().put(`${this.baseUri()}`,params);
}